import React, { Suspense } from "react";
import Loading from "loading";

const withSuspense = (WrappedComponent, Fallback = Loading) => props => (
  <Suspense fallback={<Fallback />}>
    <WrappedComponent {...props} />
  </Suspense>
);

export default withSuspense;
